<template>
    <div class="form__inlinesave">
        <a href="#" class="action" @click.prevent="open = true">Endre passord</a>
    </div>
    <Teleport to="body">
        <div class="st-modal" :class="{ 'st-modal--active': open }">
            <div class="st-modal__content">
                <div class="st-modal__header">
                    <div class="hero__header">Endre passord</div>
                </div>
                <div class="st-modal__text">
                    <template v-if="success">
                        <div class="form__message">Passordet er endret.</div>
                        <div class="mypage__editbar">
                            <button type="button" class="action action--hollow" @click="close">Lukk</button>
                        </div>
                    </template>
                    <template v-else>
                        <div v-if="error" class="form__error">{{ error }}</div>
                        <div class="change-password__field">
                            <label for="change-password-current">Nåværende passord</label>
                            <input id="change-password-current" type="password" v-model="currentPassword" autocomplete="current-password" required>
                        </div>
                        <div class="change-password__field">
                            <label for="change-password-new">Nytt passord</label>
                            <input id="change-password-new" type="password" v-model="newPassword" autocomplete="new-password" required>
                        </div>
                        <div class="change-password__field">
                            <label for="change-password-repeat">Gjenta nytt passord</label>
                            <input id="change-password-repeat" type="password" v-model="repeatPassword" autocomplete="new-password" required>
                        </div>
                        <div class="mypage__editbar">
                            <button type="button" class="action" :disabled="submitting" @click="submit">{{ submitting ? 'Lagrer...' : 'Lagre' }}</button>
                            <button type="button" class="action action--hollow" :disabled="submitting" @click="close">Avbryt</button>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    csrfToken: { type: String, required: true },
});

const open = ref(false);
const submitting = ref(false);
const success = ref(false);
const error = ref(null);
const currentPassword = ref('');
const newPassword = ref('');
const repeatPassword = ref('');

function reset() {
    submitting.value = false;
    success.value = false;
    error.value = null;
    currentPassword.value = '';
    newPassword.value = '';
    repeatPassword.value = '';
}

function close() {
    open.value = false;
    reset();
}

async function submit() {
    error.value = null;

    if (!newPassword.value || newPassword.value !== repeatPassword.value) {
        error.value = 'Passordene er ikke like.';
        return;
    }

    submitting.value = true;
    try {
        const response = await fetch('/xhr/frontend/users/change-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': props.csrfToken,
            },
            body: JSON.stringify({
                current_password: currentPassword.value,
                new_password: newPassword.value,
                new_password_confirmation: repeatPassword.value,
            }),
        });
        const data = await response.json();

        if (!response.ok) {
            error.value = data.message || 'Noe gikk galt, prøv igjen.';
            return;
        }

        success.value = true;
    } catch (e) {
        error.value = 'Noe gikk galt, prøv igjen.';
    } finally {
        submitting.value = false;
    }
}
</script>

<style scoped>
/* Teleported outside the .form/.content-width wrapper that normally styles
   text inputs (see _form.scss) - restyled here to match, but stacked with a
   real label instead of a placeholder. */
.change-password__field {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-bottom: 1rem;
}
.change-password__field label {
    font-size: 0.8rem;
    margin-bottom: 0.25rem;
}
.change-password__field input {
    border-radius: 4px;
    border: 1px solid #D3D9DE;
    background-color: #F2F5F8;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    color: #303939;
}
.change-password__field input:focus {
    outline: none;
    border-color: rgba(46, 90, 58, 0.3);
}
</style>
